import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, switchMap } from 'rxjs';

import { TokenService } from '@rx-applications/shared/auth/data-access';
import { ignoreInterceptorHeaders } from '@rx-applications/shared/utils';

@Injectable({ providedIn: 'root' })
export class AuthRequestInterceptor implements HttpInterceptor {
  constructor(private tokenService: TokenService) {}
  /* eslint-disable @typescript-eslint/no-explicit-any */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.headers.has(ignoreInterceptorHeaders.ignoreAuth) || req.url.includes('assets') || req.method === 'JSONP') {
      const requestClone = req.clone({
        headers: req.headers.delete(ignoreInterceptorHeaders.ignoreAuth),
      });
      return next.handle(requestClone);
    }

    return this.tokenService.getValidToken().pipe(switchMap((token: string) => next.handle(this.getReqClone(req, token))));
  }

  getReqClone(req: HttpRequest<any>, token: string): HttpRequest<any> {
    return token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req;
  }
}
